module.exports = __webpack_public_path__ + "static/img/aliados_epm.88cd7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alliance/aliados_epm.png
// module id = yleJ
// module chunks = 47